import React from 'react'; 
import { FieldWrapper } from '@progress/kendo-react-form';

const CusRemoveBtn = (props) => {
    const {id, label, disabled} = props;
    
    return(
        <FieldWrapper>
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <button id={id} className="box" style={{borderStyle:'none',background:'white',float:'right'}}
                    disabled={disabled}
                    onClick={e => {
                    e.preventDefault();
                    props.onClick();
                }}>
                <label style={{marginRight:'5px'}}>{label}</label>
                <span className="k-icon k-i-delete" style={{fontSize:'28px', color:'grey'}}></span>
                </button>
            </div>
        </div>
        </FieldWrapper>
    )
}

export default CusRemoveBtn;